import 'regenerator-runtime/runtime'
import './i18n'
// css 우선순위 조절하기위해 여기다 import 함: 우선순위가 최대한 낮게하고싶었음
import './components/list/tree/theme/node-content-renderer.scss'
import i18next from 'i18next'
import React from 'react'
import { render } from 'react-dom'
import '../ReactotronConfig'
import './css/base.css'
import { cache } from 'emotion'
/** @jsx jsx */
import { jsx, CacheProvider } from '@emotion/core'
// import LoadableVisibility from 'react-loadable-visibility/react-loadable'
// import LoadingCoverSimple from './components/commonInterface/loadingCoverSimple'
import ContextProvider from './helper/context'
import * as OfflinePluginRuntime from 'offline-plugin/runtime'
// import Window2 from './components/list/window2/window2'
// import OrganizingWindow from './components/composition/organizing/organizing'
// import Loadable from 'react-loadable'
import AppWithAuth from './components/composition/fullWindow'
import ErrorBoundary from './components/commonInterface/errorBoundary'
import { showToastByMenuDirection } from './helper/functions'
import { Switch, Route, HashRouter } from 'react-router-dom'
// import SharingPage from './components/sharing/sharingPage'
import SharingPageWindow from './components/sharing/sharingPageWindow'

if (process.env.NODE_ENV === 'production') {
  (function disableReactDevTools () {
    // Ensure the React Developer Tools global hook exists
    if (typeof (window.__REACT_DEVTOOLS_GLOBAL_HOOK__) !== 'object') {
      return
    }

    // Replace all global hook properties with a no-op function or a null value
    for (const prop in window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
      window.__REACT_DEVTOOLS_GLOBAL_HOOK__[prop] =
        typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__[prop] === 'function' ? function () {} : null
    }
  })()
}

if (window.todesktop) {
  window.todesktop.window.maximize()
}

OfflinePluginRuntime.install({
  onUpdateReady: () => {
    showToastByMenuDirection({
      message: i18next.t('LearnObit has updated to the latest version!'),
      intent: 'primary',
      action: {
        icon: 'updated',
        text: 'Reload Now',
        intent: 'warning',
        onClick: () => {
          OfflinePluginRuntime.applyUpdate()
        }
      },
      timeout: 0
    })
  },
  onUpdated: () => { window.location.reload() },
  onInstalled: () => {
    showToastByMenuDirection({
      icon: 'offline',
      message: i18next.t('LearnObit is ready for offline usage')
    })
  }
})
// -----------------------------------------------------------------------------------------------------------
if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line
  !(function () {
    const analytics = window.analytics = window.analytics || []
    if (!analytics.initialize) {
      if (analytics.invoked)window.console && console.error && console.error('Segment snippet included twice.'); else {
        analytics.invoked = !0; analytics.methods = ['trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview', 'identify', 'reset', 'group', 'track', 'ready', 'alias', 'debug', 'page', 'once', 'off', 'on']; analytics.factory = function (t) { return function () { var e = Array.prototype.slice.call(arguments); e.unshift(t); analytics.push(e); return analytics } }; for (var t = 0; t < analytics.methods.length; t++) { var e = analytics.methods[t]; analytics[e] = analytics.factory(e) }analytics.load = function (t, e) { var n = document.createElement('script'); n.type = 'text/javascript'; n.async = !0; n.src = 'https://cdn.segment.com/analytics.js/v1/' + t + '/analytics.min.js'; var a = document.getElementsByTagName('script')[0]; a.parentNode.insertBefore(n, a); analytics._loadOptions = e }; analytics.SNIPPET_VERSION = '4.1.0'
        analytics.load('42qJKyLNGs5P8TRLRi1cFRKgHkyUa0hO')
        analytics.page()
      }
    }
  }())
}

// if (process.env.NODE_ENV !== 'production') {
//   const { whyDidYouUpdate } = require('why-did-you-update')
//   whyDidYouUpdate(React)
// }

const root = document.getElementById('root')
export const renderApp = <><ErrorBoundary where={'global'}><ContextProvider>
  <CacheProvider value={cache}>
    <HashRouter>
      <Switch>
        <Route path={'/sharing/:userId/:nodeId'} component={SharingPageWindow} />
        <Route component={AppWithAuth} />
      </Switch>
    </HashRouter>
  </CacheProvider>
</ContextProvider></ErrorBoundary></>

const load = () => render(renderApp, root)

// This is needed for Hot Module Replacement
if (module.hot) {
  module.hot.accept('./index', load)
}

load()
